loader = require '../widget-loader/loader'

module.exports = loader.createLoader("/map/v1/index.html", "cartographerMap")
